export function handleBlurOnIframe(callback: () => void) {
  setTimeout(() => {
    const active = document.activeElement
    if (active && active.tagName === 'IFRAME') {
      return
    }

    callback()
  }, 0)
}
